// Used to compare language names in file names
export const languageNames = {
  en: 'english',
  es: 'espanol',
};

// Used to display language names with the correct diacritics
export const diacriticLanguageNames = {
  en: 'English',
  es: 'Español',
};
